// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3De-u","header":"MessagesList_header__3W9qe","chat":"MessagesList_chat__3ZK2-"};